"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Discovery Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhoAmIApi = exports.WhoAmIApiFactory = exports.WhoAmIApiFp = exports.WhoAmIApiAxiosParamCreator = exports.SerialNumberRegistryApi = exports.SerialNumberRegistryApiFactory = exports.SerialNumberRegistryApiFp = exports.SerialNumberRegistryApiAxiosParamCreator = exports.ReprovisionApi = exports.ReprovisionApiFactory = exports.ReprovisionApiFp = exports.ReprovisionApiAxiosParamCreator = exports.GenerateSerialNumberApi = exports.GenerateSerialNumberApiFactory = exports.GenerateSerialNumberApiFp = exports.GenerateSerialNumberApiAxiosParamCreator = exports.GenerateDeviceKeysApi = exports.GenerateDeviceKeysApiFactory = exports.GenerateDeviceKeysApiFp = exports.GenerateDeviceKeysApiAxiosParamCreator = exports.DiscoveryCleanUpApi = exports.DiscoveryCleanUpApiFactory = exports.DiscoveryCleanUpApiFp = exports.DiscoveryCleanUpApiAxiosParamCreator = exports.DiscoveryApi = exports.DiscoveryApiFactory = exports.DiscoveryApiFp = exports.DiscoveryApiAxiosParamCreator = exports.ProductVendorEnum = exports.ProductTypeEnum = exports.ProductModelEnum = exports.EnvironmentNames = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.EnvironmentNames = {
    STAGING: 'staging',
    DEV: 'dev',
    PROD: 'prod'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ProductModelEnum = {
    CONDUIT_IP67_BASE_STATION: 'CONDUIT_IP67_BASE_STATION',
    ER_X_SFP: 'ER_X_SFP',
    EP_R8: 'EP_R8',
    EP_R6: 'EP_R6',
    ER_POE_5: 'ER_POE_5',
    HALTER_TOWER_NODE: 'HALTER_TOWER_NODE',
    HSS_050_WITH_EPEVER: 'HSS_050_WITH_EPEVER',
    KONA_MACRO_IOT: 'KONA_MACRO_IOT',
    MODEL_UNSPECIFIED: 'MODEL_UNSPECIFIED',
    RUTX12: 'RUTX12',
    SUN_MAX_SOLAR_SWITCH: 'SUN_MAX_SOLAR_SWITCH',
    WISGATE_EDGE_PRO: 'WISGATE_EDGE_PRO'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ProductTypeEnum = {
    COLLAR: 'COLLAR',
    GATEWAY: 'GATEWAY',
    ROUTER: 'ROUTER',
    TOWER_NODE: 'TOWER_NODE',
    SOLAR_SWITCH: 'SOLAR_SWITCH',
    LED_INDICATOR: 'LED_INDICATOR'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ProductVendorEnum = {
    HALTER: 'HALTER',
    MULTI_TECH: 'MULTI_TECH',
    RAK: 'RAK',
    TEKTELIC: 'TEKTELIC',
    TELTONIKA: 'TELTONIKA',
    UBIQUITI: 'UBIQUITI',
    VENDOR_UNSPECIFIED: 'VENDOR_UNSPECIFIED'
};
/**
 * DiscoveryApi - axios parameter creator
 * @export
 */
var DiscoveryApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create new initial setup
         * @param {ICreateInitialSetupDTO} [iCreateInitialSetupDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInitialSetup: function (iCreateInitialSetupDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/discovery/initial-setups/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateInitialSetupDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary returns all initial setups within the discovery module
         * @param {string} [serialNumber] serial number from the device itself
         * @param {string} [filter] Apply filtering options to the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInitialSetup: function (serialNumber, filter, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/discovery/initial-setups/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (serialNumber !== undefined) {
                        localVarQueryParameter['serialNumber'] = serialNumber;
                    }
                    if (filter !== undefined) {
                        localVarQueryParameter['filter'] = filter;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DiscoveryApiAxiosParamCreator = DiscoveryApiAxiosParamCreator;
/**
 * DiscoveryApi - functional programming interface
 * @export
 */
var DiscoveryApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DiscoveryApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create new initial setup
         * @param {ICreateInitialSetupDTO} [iCreateInitialSetupDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInitialSetup: function (iCreateInitialSetupDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createInitialSetup(iCreateInitialSetupDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary returns all initial setups within the discovery module
         * @param {string} [serialNumber] serial number from the device itself
         * @param {string} [filter] Apply filtering options to the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInitialSetup: function (serialNumber, filter, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllInitialSetup(serialNumber, filter, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DiscoveryApiFp = DiscoveryApiFp;
/**
 * DiscoveryApi - factory interface
 * @export
 */
var DiscoveryApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DiscoveryApiFp)(configuration);
    return {
        /**
         *
         * @summary Create new initial setup
         * @param {ICreateInitialSetupDTO} [iCreateInitialSetupDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInitialSetup: function (iCreateInitialSetupDTO, options) {
            return localVarFp.createInitialSetup(iCreateInitialSetupDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary returns all initial setups within the discovery module
         * @param {string} [serialNumber] serial number from the device itself
         * @param {string} [filter] Apply filtering options to the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInitialSetup: function (serialNumber, filter, options) {
            return localVarFp.getAllInitialSetup(serialNumber, filter, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DiscoveryApiFactory = DiscoveryApiFactory;
/**
 * DiscoveryApi - object-oriented interface
 * @export
 * @class DiscoveryApi
 * @extends {BaseAPI}
 */
var DiscoveryApi = /** @class */ (function (_super) {
    __extends(DiscoveryApi, _super);
    function DiscoveryApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create new initial setup
     * @param {ICreateInitialSetupDTO} [iCreateInitialSetupDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscoveryApi
     */
    DiscoveryApi.prototype.createInitialSetup = function (iCreateInitialSetupDTO, options) {
        var _this = this;
        return (0, exports.DiscoveryApiFp)(this.configuration).createInitialSetup(iCreateInitialSetupDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary returns all initial setups within the discovery module
     * @param {string} [serialNumber] serial number from the device itself
     * @param {string} [filter] Apply filtering options to the request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscoveryApi
     */
    DiscoveryApi.prototype.getAllInitialSetup = function (serialNumber, filter, options) {
        var _this = this;
        return (0, exports.DiscoveryApiFp)(this.configuration).getAllInitialSetup(serialNumber, filter, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DiscoveryApi;
}(base_1.BaseAPI));
exports.DiscoveryApi = DiscoveryApi;
/**
 * DiscoveryCleanUpApi - axios parameter creator
 * @export
 */
var DiscoveryCleanUpApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} serialNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanUp: function (serialNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('cleanUp', 'serialNumber', serialNumber);
                    localVarPath = "/discovery/clean-up/{serialNumber}"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DiscoveryCleanUpApiAxiosParamCreator = DiscoveryCleanUpApiAxiosParamCreator;
/**
 * DiscoveryCleanUpApi - functional programming interface
 * @export
 */
var DiscoveryCleanUpApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DiscoveryCleanUpApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} serialNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanUp: function (serialNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.cleanUp(serialNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DiscoveryCleanUpApiFp = DiscoveryCleanUpApiFp;
/**
 * DiscoveryCleanUpApi - factory interface
 * @export
 */
var DiscoveryCleanUpApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DiscoveryCleanUpApiFp)(configuration);
    return {
        /**
         *
         * @param {string} serialNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanUp: function (serialNumber, options) {
            return localVarFp.cleanUp(serialNumber, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DiscoveryCleanUpApiFactory = DiscoveryCleanUpApiFactory;
/**
 * DiscoveryCleanUpApi - object-oriented interface
 * @export
 * @class DiscoveryCleanUpApi
 * @extends {BaseAPI}
 */
var DiscoveryCleanUpApi = /** @class */ (function (_super) {
    __extends(DiscoveryCleanUpApi, _super);
    function DiscoveryCleanUpApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} serialNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscoveryCleanUpApi
     */
    DiscoveryCleanUpApi.prototype.cleanUp = function (serialNumber, options) {
        var _this = this;
        return (0, exports.DiscoveryCleanUpApiFp)(this.configuration).cleanUp(serialNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DiscoveryCleanUpApi;
}(base_1.BaseAPI));
exports.DiscoveryCleanUpApi = DiscoveryCleanUpApi;
/**
 * GenerateDeviceKeysApi - axios parameter creator
 * @export
 */
var GenerateDeviceKeysApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Generates unique reserved device keys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDeviceKeys: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/discovery/generate-device-keys";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.GenerateDeviceKeysApiAxiosParamCreator = GenerateDeviceKeysApiAxiosParamCreator;
/**
 * GenerateDeviceKeysApi - functional programming interface
 * @export
 */
var GenerateDeviceKeysApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.GenerateDeviceKeysApiAxiosParamCreator)(configuration);
    return {
        /**
         * Generates unique reserved device keys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDeviceKeys: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.generateDeviceKeys(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.GenerateDeviceKeysApiFp = GenerateDeviceKeysApiFp;
/**
 * GenerateDeviceKeysApi - factory interface
 * @export
 */
var GenerateDeviceKeysApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.GenerateDeviceKeysApiFp)(configuration);
    return {
        /**
         * Generates unique reserved device keys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDeviceKeys: function (options) {
            return localVarFp.generateDeviceKeys(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.GenerateDeviceKeysApiFactory = GenerateDeviceKeysApiFactory;
/**
 * GenerateDeviceKeysApi - object-oriented interface
 * @export
 * @class GenerateDeviceKeysApi
 * @extends {BaseAPI}
 */
var GenerateDeviceKeysApi = /** @class */ (function (_super) {
    __extends(GenerateDeviceKeysApi, _super);
    function GenerateDeviceKeysApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Generates unique reserved device keys
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GenerateDeviceKeysApi
     */
    GenerateDeviceKeysApi.prototype.generateDeviceKeys = function (options) {
        var _this = this;
        return (0, exports.GenerateDeviceKeysApiFp)(this.configuration).generateDeviceKeys(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return GenerateDeviceKeysApi;
}(base_1.BaseAPI));
exports.GenerateDeviceKeysApi = GenerateDeviceKeysApi;
/**
 * GenerateSerialNumberApi - axios parameter creator
 * @export
 */
var GenerateSerialNumberApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Generates serial number for a batch of mac addresses
         * @param {string} product Version of the product to be used. For istance, for P2 it is \&quot;02\&quot;, for P4  it is \&quot;04\&quot;. This would result on a serial number like \&quot;004-xxxx-xxxxx\&quot;
         * @param {Array<IGenerateBatchSerialNumberRequestDTO>} [iGenerateBatchSerialNumberRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBatchSerialNumber: function (product, iGenerateBatchSerialNumberRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'product' is not null or undefined
                    (0, common_1.assertParamExists)('generateBatchSerialNumber', 'product', product);
                    localVarPath = "/discovery/serial-number/batch/{product}"
                        .replace("{".concat("product", "}"), encodeURIComponent(String(product)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iGenerateBatchSerialNumberRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Generates serial number for device
         * @param {string} product Version of the product to be used. For istance, for P2 it is \&quot;02\&quot;, for P4  it is \&quot;04\&quot;. This would result on a serial number like \&quot;004-xxxx-xxxxx\&quot;
         * @param {IGenerateSerialNumberRequestDTO} [iGenerateSerialNumberRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSerialNumber: function (product, iGenerateSerialNumberRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'product' is not null or undefined
                    (0, common_1.assertParamExists)('generateSerialNumber', 'product', product);
                    localVarPath = "/discovery/serial-number/{product}"
                        .replace("{".concat("product", "}"), encodeURIComponent(String(product)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iGenerateSerialNumberRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.GenerateSerialNumberApiAxiosParamCreator = GenerateSerialNumberApiAxiosParamCreator;
/**
 * GenerateSerialNumberApi - functional programming interface
 * @export
 */
var GenerateSerialNumberApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.GenerateSerialNumberApiAxiosParamCreator)(configuration);
    return {
        /**
         * Generates serial number for a batch of mac addresses
         * @param {string} product Version of the product to be used. For istance, for P2 it is \&quot;02\&quot;, for P4  it is \&quot;04\&quot;. This would result on a serial number like \&quot;004-xxxx-xxxxx\&quot;
         * @param {Array<IGenerateBatchSerialNumberRequestDTO>} [iGenerateBatchSerialNumberRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBatchSerialNumber: function (product, iGenerateBatchSerialNumberRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.generateBatchSerialNumber(product, iGenerateBatchSerialNumberRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Generates serial number for device
         * @param {string} product Version of the product to be used. For istance, for P2 it is \&quot;02\&quot;, for P4  it is \&quot;04\&quot;. This would result on a serial number like \&quot;004-xxxx-xxxxx\&quot;
         * @param {IGenerateSerialNumberRequestDTO} [iGenerateSerialNumberRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSerialNumber: function (product, iGenerateSerialNumberRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.generateSerialNumber(product, iGenerateSerialNumberRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.GenerateSerialNumberApiFp = GenerateSerialNumberApiFp;
/**
 * GenerateSerialNumberApi - factory interface
 * @export
 */
var GenerateSerialNumberApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.GenerateSerialNumberApiFp)(configuration);
    return {
        /**
         * Generates serial number for a batch of mac addresses
         * @param {string} product Version of the product to be used. For istance, for P2 it is \&quot;02\&quot;, for P4  it is \&quot;04\&quot;. This would result on a serial number like \&quot;004-xxxx-xxxxx\&quot;
         * @param {Array<IGenerateBatchSerialNumberRequestDTO>} [iGenerateBatchSerialNumberRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBatchSerialNumber: function (product, iGenerateBatchSerialNumberRequestDTO, options) {
            return localVarFp.generateBatchSerialNumber(product, iGenerateBatchSerialNumberRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Generates serial number for device
         * @param {string} product Version of the product to be used. For istance, for P2 it is \&quot;02\&quot;, for P4  it is \&quot;04\&quot;. This would result on a serial number like \&quot;004-xxxx-xxxxx\&quot;
         * @param {IGenerateSerialNumberRequestDTO} [iGenerateSerialNumberRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSerialNumber: function (product, iGenerateSerialNumberRequestDTO, options) {
            return localVarFp.generateSerialNumber(product, iGenerateSerialNumberRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.GenerateSerialNumberApiFactory = GenerateSerialNumberApiFactory;
/**
 * GenerateSerialNumberApi - object-oriented interface
 * @export
 * @class GenerateSerialNumberApi
 * @extends {BaseAPI}
 */
var GenerateSerialNumberApi = /** @class */ (function (_super) {
    __extends(GenerateSerialNumberApi, _super);
    function GenerateSerialNumberApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Generates serial number for a batch of mac addresses
     * @param {string} product Version of the product to be used. For istance, for P2 it is \&quot;02\&quot;, for P4  it is \&quot;04\&quot;. This would result on a serial number like \&quot;004-xxxx-xxxxx\&quot;
     * @param {Array<IGenerateBatchSerialNumberRequestDTO>} [iGenerateBatchSerialNumberRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GenerateSerialNumberApi
     */
    GenerateSerialNumberApi.prototype.generateBatchSerialNumber = function (product, iGenerateBatchSerialNumberRequestDTO, options) {
        var _this = this;
        return (0, exports.GenerateSerialNumberApiFp)(this.configuration).generateBatchSerialNumber(product, iGenerateBatchSerialNumberRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Generates serial number for device
     * @param {string} product Version of the product to be used. For istance, for P2 it is \&quot;02\&quot;, for P4  it is \&quot;04\&quot;. This would result on a serial number like \&quot;004-xxxx-xxxxx\&quot;
     * @param {IGenerateSerialNumberRequestDTO} [iGenerateSerialNumberRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GenerateSerialNumberApi
     */
    GenerateSerialNumberApi.prototype.generateSerialNumber = function (product, iGenerateSerialNumberRequestDTO, options) {
        var _this = this;
        return (0, exports.GenerateSerialNumberApiFp)(this.configuration).generateSerialNumber(product, iGenerateSerialNumberRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return GenerateSerialNumberApi;
}(base_1.BaseAPI));
exports.GenerateSerialNumberApi = GenerateSerialNumberApi;
/**
 * ReprovisionApi - axios parameter creator
 * @export
 */
var ReprovisionApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Deletes device from current environment and provision it in the new environment
         * @param {string} serialNumber Device serialNumber
         * @param {EnvironmentNames} environment Which environment device is gonna be reprovisioned to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reprovision: function (serialNumber, environment, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('reprovision', 'serialNumber', serialNumber);
                    // verify required parameter 'environment' is not null or undefined
                    (0, common_1.assertParamExists)('reprovision', 'environment', environment);
                    localVarPath = "/discovery/reprovision/{serialNumber}/{environment}"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)))
                        .replace("{".concat("environment", "}"), encodeURIComponent(String(environment)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ReprovisionApiAxiosParamCreator = ReprovisionApiAxiosParamCreator;
/**
 * ReprovisionApi - functional programming interface
 * @export
 */
var ReprovisionApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ReprovisionApiAxiosParamCreator)(configuration);
    return {
        /**
         * Deletes device from current environment and provision it in the new environment
         * @param {string} serialNumber Device serialNumber
         * @param {EnvironmentNames} environment Which environment device is gonna be reprovisioned to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reprovision: function (serialNumber, environment, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.reprovision(serialNumber, environment, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ReprovisionApiFp = ReprovisionApiFp;
/**
 * ReprovisionApi - factory interface
 * @export
 */
var ReprovisionApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ReprovisionApiFp)(configuration);
    return {
        /**
         * Deletes device from current environment and provision it in the new environment
         * @param {string} serialNumber Device serialNumber
         * @param {EnvironmentNames} environment Which environment device is gonna be reprovisioned to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reprovision: function (serialNumber, environment, options) {
            return localVarFp.reprovision(serialNumber, environment, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ReprovisionApiFactory = ReprovisionApiFactory;
/**
 * ReprovisionApi - object-oriented interface
 * @export
 * @class ReprovisionApi
 * @extends {BaseAPI}
 */
var ReprovisionApi = /** @class */ (function (_super) {
    __extends(ReprovisionApi, _super);
    function ReprovisionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Deletes device from current environment and provision it in the new environment
     * @param {string} serialNumber Device serialNumber
     * @param {EnvironmentNames} environment Which environment device is gonna be reprovisioned to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReprovisionApi
     */
    ReprovisionApi.prototype.reprovision = function (serialNumber, environment, options) {
        var _this = this;
        return (0, exports.ReprovisionApiFp)(this.configuration).reprovision(serialNumber, environment, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ReprovisionApi;
}(base_1.BaseAPI));
exports.ReprovisionApi = ReprovisionApi;
/**
 * SerialNumberRegistryApi - axios parameter creator
 * @export
 */
var SerialNumberRegistryApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Creates serial number registry
         * @param {ICreateSerialNumberRegistryRequestDTO} [iCreateSerialNumberRegistryRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSerialNumberRegistry: function (iCreateSerialNumberRegistryRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/discovery/serial-number-registry";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateSerialNumberRegistryRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.SerialNumberRegistryApiAxiosParamCreator = SerialNumberRegistryApiAxiosParamCreator;
/**
 * SerialNumberRegistryApi - functional programming interface
 * @export
 */
var SerialNumberRegistryApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SerialNumberRegistryApiAxiosParamCreator)(configuration);
    return {
        /**
         * Creates serial number registry
         * @param {ICreateSerialNumberRegistryRequestDTO} [iCreateSerialNumberRegistryRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSerialNumberRegistry: function (iCreateSerialNumberRegistryRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSerialNumberRegistry(iCreateSerialNumberRegistryRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SerialNumberRegistryApiFp = SerialNumberRegistryApiFp;
/**
 * SerialNumberRegistryApi - factory interface
 * @export
 */
var SerialNumberRegistryApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SerialNumberRegistryApiFp)(configuration);
    return {
        /**
         * Creates serial number registry
         * @param {ICreateSerialNumberRegistryRequestDTO} [iCreateSerialNumberRegistryRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSerialNumberRegistry: function (iCreateSerialNumberRegistryRequestDTO, options) {
            return localVarFp.createSerialNumberRegistry(iCreateSerialNumberRegistryRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SerialNumberRegistryApiFactory = SerialNumberRegistryApiFactory;
/**
 * SerialNumberRegistryApi - object-oriented interface
 * @export
 * @class SerialNumberRegistryApi
 * @extends {BaseAPI}
 */
var SerialNumberRegistryApi = /** @class */ (function (_super) {
    __extends(SerialNumberRegistryApi, _super);
    function SerialNumberRegistryApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates serial number registry
     * @param {ICreateSerialNumberRegistryRequestDTO} [iCreateSerialNumberRegistryRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SerialNumberRegistryApi
     */
    SerialNumberRegistryApi.prototype.createSerialNumberRegistry = function (iCreateSerialNumberRegistryRequestDTO, options) {
        var _this = this;
        return (0, exports.SerialNumberRegistryApiFp)(this.configuration).createSerialNumberRegistry(iCreateSerialNumberRegistryRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SerialNumberRegistryApi;
}(base_1.BaseAPI));
exports.SerialNumberRegistryApi = SerialNumberRegistryApi;
/**
 * WhoAmIApi - axios parameter creator
 * @export
 */
var WhoAmIApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns a initial setup\'s information using the mac to serial number mapping
         * @param {string} mac Mac address from the device itself
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whoAmI: function (mac, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'mac' is not null or undefined
                    (0, common_1.assertParamExists)('whoAmI', 'mac', mac);
                    localVarPath = "/discovery/who-am-i/{mac}"
                        .replace("{".concat("mac", "}"), encodeURIComponent(String(mac)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.WhoAmIApiAxiosParamCreator = WhoAmIApiAxiosParamCreator;
/**
 * WhoAmIApi - functional programming interface
 * @export
 */
var WhoAmIApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.WhoAmIApiAxiosParamCreator)(configuration);
    return {
        /**
         * Returns a initial setup\'s information using the mac to serial number mapping
         * @param {string} mac Mac address from the device itself
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whoAmI: function (mac, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.whoAmI(mac, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.WhoAmIApiFp = WhoAmIApiFp;
/**
 * WhoAmIApi - factory interface
 * @export
 */
var WhoAmIApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.WhoAmIApiFp)(configuration);
    return {
        /**
         * Returns a initial setup\'s information using the mac to serial number mapping
         * @param {string} mac Mac address from the device itself
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whoAmI: function (mac, options) {
            return localVarFp.whoAmI(mac, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.WhoAmIApiFactory = WhoAmIApiFactory;
/**
 * WhoAmIApi - object-oriented interface
 * @export
 * @class WhoAmIApi
 * @extends {BaseAPI}
 */
var WhoAmIApi = /** @class */ (function (_super) {
    __extends(WhoAmIApi, _super);
    function WhoAmIApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns a initial setup\'s information using the mac to serial number mapping
     * @param {string} mac Mac address from the device itself
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhoAmIApi
     */
    WhoAmIApi.prototype.whoAmI = function (mac, options) {
        var _this = this;
        return (0, exports.WhoAmIApiFp)(this.configuration).whoAmI(mac, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return WhoAmIApi;
}(base_1.BaseAPI));
exports.WhoAmIApi = WhoAmIApi;
